import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue';
import { faTimes, faSearch } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
    value: { default: '' },
    placeholder: null,
    clearable: { type: Boolean, default: true },
    theme: { default: 'dark' }
  },
  emits: ["submit", "search", "focus", "keydown"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: 'submit', value: string): void;
	(e: 'search', value: string): void;
	(e: 'focus', event: Event): void;
	(e: 'keydown', event: KeyboardEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string, placeholder: string, clearable: boolean, theme: 'dark' | 'light' };





const searchQuery = ref('');

onMounted(() => {
	// Set the initial value of the search query
	searchQuery.value = props.value;
});

watch(
	() => props.value,
	newValue => {
		searchQuery.value = newValue;
	}
);

function emitSearchEvent() {
	return emits('search', searchQuery.value);
}

function clearSearchQuery() {
	searchQuery.value = '';
	emitSearchEvent();
}

function updateSearchQuery(event: Event) {
	searchQuery.value = (event.target as HTMLInputElement).value.trim();
	emitSearchEvent();
}

return { __sfc: true,props, emits, searchQuery, emitSearchEvent, clearSearchQuery, updateSearchQuery, faTimes, faSearch }
}

})